/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OverrideStandingItem
 */
export interface OverrideStandingItem {
    /**
     * 
     * @type {number}
     * @memberof OverrideStandingItem
     */
    place?: number;
    /**
     * 
     * @type {string}
     * @memberof OverrideStandingItem
     */
    teamId?: string;
    /**
     * 
     * @type {number}
     * @memberof OverrideStandingItem
     */
    prizeAmount?: number;
}

/**
 * Check if a given object implements the OverrideStandingItem interface.
 */
export function instanceOfOverrideStandingItem(value: object): value is OverrideStandingItem {
    return true;
}

export function OverrideStandingItemFromJSON(json: any): OverrideStandingItem {
    return OverrideStandingItemFromJSONTyped(json, false);
}

export function OverrideStandingItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): OverrideStandingItem {
    if (json == null) {
        return json;
    }
    return {
        
        'place': json['place'] == null ? undefined : json['place'],
        'teamId': json['teamId'] == null ? undefined : json['teamId'],
        'prizeAmount': json['prizeAmount'] == null ? undefined : json['prizeAmount'],
    };
}

export function OverrideStandingItemToJSON(json: any): OverrideStandingItem {
    return OverrideStandingItemToJSONTyped(json, false);
}

export function OverrideStandingItemToJSONTyped(value?: OverrideStandingItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'place': value['place'],
        'teamId': value['teamId'],
        'prizeAmount': value['prizeAmount'],
    };
}

